// extracted by mini-css-extract-plugin
export default {"login":"Login_login__3ypdf","login-with-google-btn":"Login_login-with-google-btn__bu7fj"};